export class AssignTickets{
    id:number;
    ticketNumber:string;
    userId:string;
    modifiedBy:string;
}
export class PaginationReq{
    sort:string;
    sortColumn:string;
    pageNumber:number;
    pageSize:number = 10;
    statusId:Array<number>;
    departmentId:Array<number>;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/ticketingsystem/bulk-assign-tickets-req.ts